import { pluginFactory } from './utils/plugins';

//
// Utility Plugin for setting the configuration
//
const BVConfigPlugin = /*#__PURE__*/pluginFactory();

export { BVConfigPlugin };
